module.exports = __webpack_public_path__ + "media/partenaire/note-landscape-d3300b30.png";